import { render, staticRenderFns } from "./SelectStatusProjeto.vue?vue&type=template&id=f847893e&scoped=true"
import script from "./SelectStatusProjeto.vue?vue&type=script&lang=js"
export * from "./SelectStatusProjeto.vue?vue&type=script&lang=js"
import style0 from "./SelectStatusProjeto.vue?vue&type=style&index=0&id=f847893e&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f847893e",
  null
  
)

export default component.exports